$(function() {
	$('body').trigger('fx-ready');
});
